import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AreaForm from "../../../../screens/places/components/AreaForm";

export default function CountriesEdit(props) {
  const { t } = useTranslation();
  let { id } = useParams();
  return (
    <AreaForm
      resourceUrl={`/countries/${id}`}
      resourceKey="Countries"
      breadcrumbs={[{ content: t("countries.breadcrumbs.countries"), url: "/places/countries" }]}
    />
  );
}
